export function getElement(id: string) {
  return document.querySelector(`#${id}`)
}

export function bringInView(id: string) {
  const element = getElement(id)
  if (!id || !element || isElementInView(id)) {
    return
  }

  element.scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'center',
  })
}

export function isElementInView(id: string) {
  const element = getElement(id) as HTMLElement
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export function isElementVisible(el: HTMLElement) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
}

export function getDomRectPos(el: HTMLElement) {
  const { bottom, top, right, left, width, height } = el.getBoundingClientRect()

  return {
    width,
    bottom,
    height,
    right,
    top: top + window.scrollY,
    left: left || el.offsetLeft,
    centerX: left + Math.floor(width / 2),
    centerY: top + Math.floor(height / 2),
  }
}

export const ELEMENT_ID_LIST = [
  'zk_connect_button',
  // 'zk_connect_button',
  // 'zk_network_select',
  'zk_market_symbol',
  'zk_tv_chart',
  'zk_order_book',
  'zk_buy_button',
  'zk_order_mode',
  'zk_order_slider',
  'zk_account_balance',
  'zk_post_only',
  'zk_connect_order_button',
  'zk_order_container',
]

export const LINK = [
  'https://docs.zkex.com/overview/copy-of-fee',
  'https://docs.zkex.com/overview/supported-chains-and-coins',
  'https://docs.zkex.com/overview/readme-1',
  'https://docs.zkex.com/overview/trading',
]
